import script from "./EthereumAddressTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./EthereumAddressTransactions.vue?vue&type=script&setup=true&lang=js"

import "./EthereumAddressTransactions.vue?vue&type=style&index=0&id=ee823e96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee823e96"]])

export default __exports__